<template>
  <div class="banner-pic">
    <div class="wrapper">
      <div class="bannertext">
        <bannertext :firstpicture="firstpicture">
          <h1 slot="title">
            {{ words.title }}
            <small>{{ words.smalltitle }}</small>
          </h1>
          <h2 slot="subtitle">{{ words.subtitle }}</h2>
          <p slot="content">{{ words.content }}</p>
        </bannertext>
      </div>
      <div class="slideshow">
        <slideshow :pictures="pictures"></slideshow>
      </div>
    </div>
  </div>
</template>

<script>
import bannertext from '@/components/banner_text.vue';
import slideshow from '@/components/banner_slideshow.vue';

export default {
  props: {
    words: {
      type: Object,
      default: () => ({
        title: '這是100px標題',
        smalltitle: '這是65px標題',
        subtitle: '這是40px標題',
        content: 'Lorem ipsum dolor,sit amet consectetur adipisicing elit. Magnam, consequatur!',
      }),
    },
    pictures: {
      type: Array,
      default: () => ([
        '這是來自banner_pic的default',
        '外層-Banner-banner_pic-slideshow',
        '總共有4層，這裡是外面數來第三層',
      ]),
    },
  },
  data() {
    return {
      firstpicture: this.pictures[0],
    };
  },
  components: {
    bannertext,
    slideshow,
  },
};
</script>

<style scoped lang="scss">
.banner-pic{
  position: relative;
  box-shadow: 0px -1px 10px #dac4a9;
  .wrapper{
    display: flex;
    .bannertext{
      width: 40%;
    }
    .slideshow{
      width: 60%;
    }
  }
}

@media screen and ( max-width: 1000px ) {
  .banner-pic{
    .wrapper{
      display: flex;
      .bannertext{
        width: 100%;
      }
      .slideshow{
        display: none;
      }
    }
  }
}
</style>
